export const gu = {
	switchTheme: 'થીમ બદલો',
	next: 'આગળ',
	total: 'કુલ',
	stepOf: 'પગથિયું {current} માંથી {length}',
	industryBench: 'ઉદ્યોગ ધોરણ',
	industryComingSoon: 'ઉદ્યોગ સરેરાશ શીઘ્ર જ આવી રહ્યું છે',
	employees: 'કર્મચારીઓ',
	slogan: 'વિશ્વવ્યાપી ટીમો દ્વારા વિશ્વસનીય અને પ્રેમથી અપનાવાયેલ',
	'estimated.time': 'અંદાજિત સમય',
	'changePassword.title': 'પાસવર્ડ બદલો',
	'auth.createAccount': 'ખાતું બનાવો',
	'auth.createAnAccount': 'ખાતું બનાવો',
	'auth.createYourAccount': 'તમારું ખાતું બનાવો',
	'auth.createProfile': 'તમારું પ્રોફાઇલ બનાવો',
	'auth.signIn': 'પ્રવેશ કરો',
	'auth.signUp': 'સાઇન અપ કરો',
	'auth.login': 'લૉગિન',
	'auth.signInAccount': 'તમારા ખાતામાં પ્રવેશ કરો',
	'auth.acceptTerms':
		'ખાતું બનાવવાનો અર્થ એ છે કે તમે અમારી {terms} અને {privacy} થી સહમત છો <red>*</red>',

	'auth.terms': 'સેવાના શરતો',
	'auth.privacy': 'ગોપનીયતા નીતિ',
	'auth.dontHaveAnAccount': 'ખાતું નથી?',
	'auth.haveAccount': 'પહેલેથી જ એકાઉન્ટ છે?',
	'auth.signUpWith': '{name} સાથે સાઇન અપ કરો',
	'auth.signInWith': '{name} સાથે સાઇન ઇન કરો',
	'auth.message.quote': `પરિણામો આશ્ચર્યજનક હતા અને અમેએ એમમાંથી એકને રાખ્યો.  
    કાશ! હું 500 અરજીઓમાંથી પસાર થયા પહેલા જ તેમની સાથે શરૂ કરત!`,
	'validation.lowercase':
		'{length, plural, =1 {એક} other {#}} નાનું અક્ષર {length, plural, =1 {અક્ષર} other {અક્ષરો}}',
	'validation.uppercase':
		'{length, plural, =1 {એક} other {#}} મોટું અક્ષર {length, plural, =1 {અક્ષર} other {અક્ષરો}}',
	'validation.special':
		'{length, plural, =1 {એક} other {#}} વિશિષ્ટ {length, plural, =1 {અક્ષર} other {અક્ષરો}}',
	'validation.number':
		'{length, plural, =1 {એક} other {#}} {length, plural, =1 {અંક} other {અંકો}}',
	'validation.minLength':
		'{length, plural, =0 {} =1 {ઓછામાં ઓછો એક અક્ષર} other {ઓછામાં ઓછા # અક્ષરો}}',
	'validation.maxLength': 'મહત્તમ લંબાઈ {length, number}',
	'validation.emailIncluded': 'આ ઈમેલ પહેલેથી જ સામેલ છે',
	'auth.forgotPassword': 'પાસવર્ડ ભૂલી ગયા?',
	'nav.organizations': 'સંસ્થાઓ',
	'nav.addOrg': 'નવી સંસ્થા ઉમેરો',
	'nav.personalInformation': 'ખાતું',
	'nav.campaigns': 'પ્રચાર',
	'nav.integrations': 'ઈન્ટિગ્રેશન',
	'nav.company': 'કંપની',
	'nav.security': 'સુરક્ષા',

	'nav.billing': 'બિલિંગ',
	'statusButton.nextStatus': 'આગલો સ્થિતિ:',
	'invite.challenge': 'પ્રતિભા આમંત્રણ',
	'invite.challengeLink': 'ચેલેન્જ લિંક કૉપિ કરો અને {type} ને મોકલો',
	'invite.challenge.success': '{name} ની ચેલેન્જ લિંક સફળતાપૂર્વક ક્લિપબોર્ડમાં કૉપિ થઈ',
	'invite.challenge.uploadEmailFileDropZone': 'તમારો ફાઈલ અહીં ખેંચીને મૂકો',
	'talentGroup.menu.emailReminder': 'ઈમેલ રીમાઇન્ડર મોકલો',
	'talentGroup.menu.copyChallenge': 'ચેલેન્જ કૉપિ કરો',
	'talentGroup.menu.deleteGroup': 'સમૂહ કાઢી નાંખો',
	'talentGroup.sendNotification': 'નવી પ્રતિભાઓને ચેલેન્જ આપવા માટે આમંત્રણ ઈમેલ મોકલો',
	'dashboard.welcome.hello': 'નમસ્તે, {name}',
	'dashboard.emailVerified': 'ઈમેલ ચકાસાયેલ!',
	'dashboard.welcome.firstTime.welcome': 'તમારા ડેશબોર્ડમાં સ્વાગત છે!',
	'dashboard.welcome.firstTime.createTeam': 'પ્રારંભ કરવા માટે એક ટીમ બનાવો',
	'dashboard.welcome.createTeam': 'કોઈ ટીમમાં ક્લિક કરો અથવા નવી બનાવો',
	'dashboard.welcome.box.title': 'ચાલો શરૂ કરીએ!',
	'dashboard.welcome.box.subText':
		'પ્રથમ ટીમ બનાવો જેથી તમે પ્રતિભાને ભરતી કરી શકો અથવા કર્મચારી ક્ષમતાઓનું મૂલ્યાંકન કરી શકો.',
	'dashboard.welcome.box.buttonText': 'ટીમ બનાવો',
	'dashboard.welcome.box.trialEnded':
		'તમારું મફત ટ્રાયલ સમાપ્ત થયું છે અથવા તમારું પ્લાન રદ કરવામાં આવ્યું છે.',
	'dashboard.welcome.firstTime.naomi.welcome': 'તમારા ડેશબોર્ડમાં સ્વાગત છે!',
	'dashboard.welcome.firstTime.naomi.welcomeBalloon': 'સ્વાગત છે!',
	'dashboard.welcome.firstTime.naomi.description':
		'હું નાઓમી છું, પ્લેટફોર્મ પાછળની શક્તિશાળી AI એન્જિન, અને હું તમને ટીમો બનાવવા, કુશળતાઓ માપવા અને સમય સાથે આંતરદૃષ્ટિઓ વિશ્લેષણ કરવામાં સહાય કરીશ.',
	'dashboard.welcome.firstTime.seeDashboard': 'મારું ડેશબોર્ડ જુઓ!',
	'dashboard.welcome.firstTime.welcomeMessage': `હું નાઓમી છું, પ્લેટફોર્મ પાછળની શક્તિશાળી AI એન્જિન, અને હું  
    તમને ટીમો બનાવવા, કુશળતાઓ માપવા અને સમય સાથે આંતરદૃષ્ટિઓ વિશ્લેષણ કરવામાં સહાય કરીશ.`,
	'dashboard.trialExpired.title': 'તમારું 14 દિવસનું મફત ટ્રાયલ સમાપ્ત થયું છે',

	'dashboard.trialExpired.desc':
		'ચિંતા કરવાની જરૂર નથી, તમને હજી પણ તમારાં બધી માહિતીની એક્સેસ છે, પરંતુ તમારું પ્રોફાઇલ હવે મર્યાદિત ક્રિયાઓ સાથે લોક થયેલું છે. સંપૂર્ણ એક્સેસ પુનઃપ્રાપ્ત કરવા માટે એક પ્લાન પસંદ કરો.',
	'teams.challengeDetails': 'ચેલેન્જ વિગતો જુઓ',
	'teams.addTalent': 'પ્રતિભા આમંત્રણ',
	'talentGroup.createNewGroup': 'નવો સમૂહ બનાવો',
	'teams.createGroup': 'સમૂહ બનાવો',
	'teams.talentGroup': 'પ્રતિભા સમૂહ',
	'teams.attempts': 'પ્રયાસો',
	'teams.totalTalent': 'કુલ {total, plural, =1 {પ્રતિભા: } other {પ્રતિભાઓ: }}',
	'teams.totalGroup': 'કુલ {total, plural, =1 {સમૂહ: } other {સમૂહો: }}',
	'teams.searchInputPlaceholder': 'પ્રતિભા, પ્રતિભા સમૂહ શોધો',
	'teams.searchGroupPlaceholder': 'ટીમ નામ દ્વારા શોધો',
	'teams.profile.noTalentSelect': 'કોઈ પ્રતિભા પસંદ કરાઈ નથી',
	'teams.profile.noTalentFound': 'કોઈ પ્રતિભા મળી નથી',
	'teams.profile.noTalentAdded': 'હજી સુધી કોઈ પ્રતિભા ઉમેરાઈ નથી',
	'teams.profile.clickOnProfile':
		'{direction} પરની પ્રતિભા ક્લિક કરો જેથી તેમની પ્રોફાઇલ અહીં જોઈ શકો!',
	'teams.talent': 'પ્રતિભા',
	'teams.talent.filter.progress': 'પ્રગતિ',
	'teams.talent.filter.createdat': 'છેલ્લે ઉમેરાયેલ',
	'teams.talent.filter.updatedat': 'છેલ્લે અપડેટ થયેલું',
	'teams.talent.filter.score': 'સ્કોર',
	'teams.talent.filter.name': 'નામ',
	'teams.talentGroups.filter': 'દાખવટ:',
	'teams.talentGroups.filter.all': 'બધા',
	'teams.talentGroups.filter.internal': 'કર્મચારીઓ',
	'teams.talentGroups.filter.external': 'ઉમેદવાર',
	'teams.talentProfile': 'પ્રતિભા પ્રોફાઇલ',
	'teams.talentDynamic': 'પ્રતિભા ગતિશીલતા',

	'teams.talentProfile.profile': 'નગેટ પ્રોફાઇલ જુઓ',
	'teams.talentProfile.profileTooltip':
		'{name} પાસે જાહેર નગેટ પ્રોફાઇલ છે. તપાસવા માટે ક્લિક કરો',
	'teams.talentDynamic.talent.description':
		'નીચેની પ્રતિભા ટૅગ પર ક્લિક કરો જેથી તેને ઉપરના ગ્રાફમાં પિન કરી શકો',
	'teams.talent.all': 'બધા ({total})',
	'teams.talent.employee': 'કર્મચારીઓ ({total})',
	'teams.talent.candidate': 'ઉમેદવારો ({total})',
	'jobs.notFound': 'કોઈ નોકરી મળી નથી!',
	'jobs.assignTeamMate': 'ટીમ સાથીગણોને સોંપો',
	'jobs.assignTeamMate.placeholder': 'વપરાશકર્તાનું નામ લખો, પછી એન્ટર દબાવો',
	'jobs.assignTeamMate.jobRole': 'નોકરી ભૂમિકા',
	'jobs.import': 'નોકરીઓ આયાત કરો',
	'jobs.noJobs':
		'તમે ટોચના જમણા ખૂણાના "નવી નોકરી બનાવો" બટન પર ક્લિક કરીને નોકરીઓ બનાવવાનું શરૂ કરી શકો છો!',
	'jobs.entryLevel': 'પ્રારંભ સ્તર - {jobType}',
	'jobs.closeDate': 'બંધ થવાની તારીખ - {closeDate}',
	'jobs.edit': 'નોકરી સંપાદિત કરો',
	'jobs.edit.desc':
		'આ મેનુમાં તમે નોકરીની સેટિંગ્સ સંપાદિત કરી શકો છો અને ફરી સમીક્ષા માટે મોકલી શકો છો.',
	'jobs.assign': 'સોંપો',
	'jobs.assign.desc': 'આ નોકરી માટે નિયુક્ત ટીમ સાથીઓનું સંચાલન કરો',
	'jobs.delete': 'નોકરી કાઢી નાંખો',
	'jobs.delete.desc': 'નોકરીની જાહેરાત હંમેશા માટે કાઢી નાંખો',
	'jobs.delete.body':
		'શું તમે ખરેખર <bold>{name}</bold> કાઢી નાંખવા માંગો છો? તેની બધી સામગ્રી કાયમ માટે કાઢી નાખવામાં આવશે અને પુનઃપ્રાપ્ત કરી શકાશે નહીં',
	'jobs.public': 'જાહેર',
	'jobs.public.desc':
		'ટીમમાં કોણ નોકરી પોસ્ટિંગ જોઈ શકે તે નિયંત્રિત કરવા માટે ચાલુ/બંધ કરો',
	'jobs.createdBy': '{name} દ્વારા બનાવેલ',
	'jobs.draft': 'ડ્રાફ્ટ',

	'jobs.active': 'સક્રિય',
	'jobs.permission.0': 'સંપાદક',
	'jobs.permission.1': 'દર્શક',
	'jobs.status': 'નોકરીની સ્થિતિ',
	'jobs.type': 'નોકરી પ્રકાર',
	'jobs.creator': 'નોકરી સર્જક',
	'accountSettings.title': 'સેટિંગ્સ',
	'accountSettings.account': 'ખાતા',
	'accountSettings.billing': 'બિલિંગ',
	'accountSettings.security': 'સુરક્ષા',
	'accountSettings.notification': 'સૂચના',
	'accountSettings.emailVerified': 'ઈમેલ ચકાસાયેલ',
	'accountSettings.emailNotVerified': 'ઈમેલ ચકાસાયેલ નથી',
	'accountSettings.placeholder.username': 'તમારું પહેલું નામ',
	'accountSettings.placeholder.lastname': 'તમારું છેલ્લું નામ',
	'accountSettings.billing.title': 'ઉપલબ્ધ પ્લાન્સ',
	'accountSettings.billing.bothPlansCancelled.title':
		'તમારા {plan1} અને {plan2} પ્લાન્સ રદ કરવામાં આવ્યા છે',
	'accountSettings.billing.bothPlansCancelled.desc':
		'તમે હજી પણ <bold>{date}</bold> સુધી {plan1} અને {plan2} સુવિધાઓનો ઉપયોગ કરી શકશો.',
	'accountSettings.billing.bothPlansCancelled.subdesc':
		'<bold>નોંધ</bold>: બિલિંગ ચક્રના અંતે પ્રતિભા બેન્ચમાર્કિંગ માટે અંતિમ ચુકવણી લેવામાં આવશે.',
	'accountSettings.billing.hiring.title': 'તમારો પ્રતિભા획્તિ પ્લાન રદ કરવામાં આવ્યો છે',
	'accountSettings.billing.hiring.message':
		'તમે <bold>{date}</bold> સુધી પ્રતિભા획્તિ પ્લાનની સુવિધાઓનો ઉપયોગ કરી શકશો.',
	'accountSettings.billing.benchmarking.title':
		'તમારો પ્રતિભા બેન્ચમાર્કિંગ પ્લાન રદ કરવામાં આવ્યો છે',
	'accountSettings.billing.benchmarking.message':
		'તમે <bold>{date}</bold> સુધી બેન્ચમાર્કિંગ પ્લાનની સુવિધાઓનો ઉપયોગ કરી શકશો. કોઈ પણ વધારાના કર્મચારીઓ માટે અંતિમ ચુકવણી લેવામાં આવશે.',

	'accountSettings.billing.myPlans': 'મારા પ્લાન્સ',
	'accountSettings.billing.nextPayment': 'તમારી આગામી ચુકવણી {date} ના રોજ નિર્ધારિત છે',
	'accountSettings.billing.isCancelled': 'રદ કરવાની યોજના બનાવાઈ છે',
	'accountSettings.billing.benchmarking.no.nextPayment':
		'અંતિમ ચુકવણી {date} ના રોજ નિર્ધારિત છે.',
	'accountSettings.billing.hiring.no.nextPayment': 'સક્રિય રહેશે {date} સુધી.',
	'accountSettings.billing.benchmarking.note':
		'* નોંધ: અમે માત્ર તે કર્મચારીઓ માટે જ ચાર્જ કરીએ છીએ, જેમણે આખી ચેલેન્જ પૂર્ણ કરી હોય. જ્યારે તેમનો પ્રગતિ દર 100% પહોંચે ત્યારે તમે આ મૂલવી શકો છો.',
	'accountSettings.billing.desc':
		'તમે હમણાં જે પ્લાન લઈ રહ્યા છો, તેના ઉપર વધારાનો પ્લાન ઉમેરવાનો વિકલ્પ ઉપલબ્ધ છે.',
	'companySettings.drag&DropYourLogo': 'તમારું લોગો અહીં ખેંચો અને મૂકો',
	'companySettings.dropYourFiles': 'તમારી ફાઇલો અહીં મૂકો',
	'org.placeholder.industry': 'તમારી કંપનીનો ઉદ્યોગ',
	'org.placeholder.companySize': 'તમારી કંપનીનું કદ',
	'org.placeholder.name': 'તમારી કંપનીનું નામ',
	'org.company': 'કંપની',
	'org.companyName': 'કંપનીનું નામ',
	'org.companyLogo': 'કંપની લોગો',
	'org.yourRole': 'તમારું ભૂમિકા',
	'org.companySize': 'કંપનીનું કદ',
	'org.companyIndustry': 'કંપની ઉદ્યોગ',
	'changePassword.currentPassword': 'હાલનું પાસવર્ડ',
	'changePassword.newPassword': 'નવું પાસવર્ડ',
	'changePassword.confirmNewPassword': 'નવું પાસવર્ડ પુષ્ટિ કરો',
	'changePassword.passwordError': 'પાસવર્ડ મેળ ખાતો નથી',
	'changePassword.success': 'પાસવર્ડ સફળતાપૂર્વક અપડેટ થયો.',
	'addPassword.success': 'પાસવર્ડ સફળતાપૂર્વક ઉમેરાયો.',
	'accountSettings.security.deleteAccount.title': 'ખાતું કાઢી નાંખો',
	'accountSettings.security.deleteAccount.description':
		'તમે આ ખાતું અને તેની બધી માહિતી ગુમાવશો. આ પ્રક્રિયા પાછી ફેરવી શકાતી નથી.',

	'auth.forgotPassword.0.title': 'પાસવર્ડ ભૂલી ગયા?',
	'auth.forgotPassword.0.desc': 'તમારા ખાતા સાથે જોડાયેલ ઇમેલ એડ્રેસ દાખલ કરો',
	'auth.forgotPassword.1.title': 'તમારું ઇમેલ ચકાસો',
	'auth.forgotPassword.1.desc': 'કૃપા કરીને {email} પર મોકલવામાં આવેલ 4 અંકનો કોડ દાખલ કરો',
	'auth.forgotPassword.2.title': 'પાસવર્ડ રીસેટ કરો',
	'auth.forgotPassword.2.desc': 'તમારો નવો પાસવર્ડ દાખલ કરો',
	'auth.forgotPassword.success.title': 'અભિનંદન!',
	'auth.forgotPassword.success.msg': 'તમારો પાસવર્ડ સફળતાપૂર્વક રીસેટ થયો છે',
	'auth.forgotPassword.resetPassword': 'પાસવર્ડ રીસેટ કરો',
	'alert.trial.expired':
		'કોઈ પ્લાન સક્રિય નથી. સુપરટેલેન્ટનો ઉપયોગ ચાલુ રાખવા માટે પ્લાન સક્રિય કરો',
	'alert.benchmarking.plan.canceled':
		'તમારું {plan} પ્લાન <bold>રદ કરવામાં આવશે અને {date} પર અંતિમ ચુકવણી લેવામાં આવશે</bold>',
	'alert.hiring.plan.canceled':
		'તમારું {plan} પ્લાન <bold>{date}</bold> પર રદ કરવામાં આવશે',
	'alert.plans.canceled': 'તમારા {first} અને {second} પ્લાન {date} પર રદ કરવામાં આવશે',
	'alert.plan.failed':
		'તમારા {plan} પ્લાન માટે છેલ્લી ચુકવણી નિષ્ફળ ગઈ છે. કૃપા કરીને સેટિંગ્સ > બિલિંગ માંથી ગ્રાહક બિલિંગ પોર્ટલમાં તમારી ક્રેડિટ કાર્ડ વિગતો અપડેટ કરો. અમે આગામી 2 અઠવાડિયામાં 4 વખત પુનઃપ્રયાસ કરીશું, તે પછી તમારું પ્લાન રદ કરવામાં આવશે.',
	'alert.bothPlans.failed':
		'તમારા {benchmarking} અને {hiring} પ્લાન માટે છેલ્લી ચુકવણી નિષ્ફળ ગઈ છે. કૃપા કરીને સેટિંગ્સ > બિલિંગ માંથી ગ્રાહક બિલિંગ પોર્ટલમાં તમારું ક્રેડિટ કાર્ડ અપડેટ કરો. અમે આગામી 2 અઠવાડિયામાં 4 વખત પુનઃપ્રયાસ કરીશું, તે પછી તમારા પ્લાન રદ કરવામાં આવશે.',
	'alert.remaining.trial.days': 'તમારો ટ્રાયલ {value} દિવસમાં સમાપ્ત થશે',
	'alert.trial.endToday': 'તમારો ટ્રાયલ આજે સમાપ્ત થઈ રહ્યો છે',
	activatePlan: 'પ્લાન સક્રિય કરો',
	reactivatePlan: 'પ્લાન પુનઃસક્રિય કરો',
	viewDashboard: 'ડેશબોર્ડ જુઓ',
	'header.settings': 'સેટિંગ્સ',
	'header.logOut': 'લૉગ આઉટ',
	'mailVerification.verify': 'કૃપા કરીને તમારું ઇમેલ એડ્રેસ ચકાસો',
	'mailVerification.emailSent':
		'ચકાસણી ઈમેલ મોકલવામાં આવ્યો છે. પ્રક્રિયા પૂર્ણ કરવા માટે, કૃપા કરીને તમારું ઇનબોક્સ તપાસો.',

	'mailVerification.verified': 'તમારું ઇમેલ સફળતાપૂર્વક ચકાસવામાં આવ્યું!',
	'mailVerification.resendButton': 'ઇમેલ ફરીથી મોકલો',
	'mailVerification.resendButtonMobile': 'ઇમેલ ચકાસણી ફરીથી મોકલો',
	'mailVerification.resendMessage': 'ઇમેલ સફળતાપૂર્વક મોકલાયું',
	'mailVerification.teams': 'ટીમ બનાવવા માટે તમારું ઇમેલ ચકાસવું જરૂરી છે!',
	'tooltip.teamDynamic': `નીચેનું સ્પાઇડર ગ્રાફ તમારી ટેલેન્ટ ગ્રૂપ્સ અને ટેલેન્ટના કૌશલ્ય સ્તરો દર્શાવે છે.
	ગ્રાફમાં બતાવવા અથવા છુપાવવા માટે ટેલેન્ટ ગ્રુપ અથવા વ્યક્તિગત ટેલેન્ટ પર ક્લિક કરો.`,
	'tooltip.talentGroup': 'ટેલેન્ટને અલગ ગ્રૂપમાં વહેંચવું શ્રેષ્ઠ પ્રથા છે.',
	'tooltip.emailReminder': 'ચેલેન્જ પૂર્ણ કરવા માટે ઇમેલ રીમાઇન્ડર મોકલો',
	continue: 'ચાલુ રાખો',
	pin: 'પિન',
	shortlist: 'શોર્ટલિસ્ટ',
	removeShortlist: 'શોર્ટલિસ્ટમાંથી કાઢી નાંખો',
	customFields: 'કસ્ટમ ફીલ્ડ્સ',
	modifyTalent: 'ગ્રૂપ્સ બદલો',
	exportPdf: 'PDF માં નિકાસ કરો',
	deleteTalent: 'ટેલેન્ટ કાઢી નાંખો',
	delete: 'કાઢી નાંખો',
	settings: 'સેટિંગ્સ',
	save: 'સાચવો',
	back: 'પાછળ',
	backTo: '{place} પર પાછા જાઓ',
	clear: 'સાફ કરો',
	clearAll: 'બધું સાફ કરો',
	welcome: 'સ્વાગત છે',
	fieldName: 'ક્ષેત્ર નામ',
	value: 'મૂલ્ય',

	nodata: 'માહિતી નથી',
	activate: 'સક્રિય કરો',
	'payment.startingAt': 'શરૂઆતથી',
	'payment.simple.pricing': 'સરળ કિંમતો',
	'payment.monthly': 'મહિનો',
	'payment.yearly': 'વર્ષ',
	'payment.calculate.cost.desc':
		'તમારા ખાતામાં સક્રિય કર્મચારી પ્રોફાઇલોની સંખ્યાના આધારે ગ્રેજ્યુએટેડ કિંમત યોજના અનુસાર તમારો ખર્ચ મહિનાના અંતે ગણવામાં આવે છે.',
	'payment.calculate.cost.desc.0':
		'ઉદાહરણ તરીકે, જો તમારી પાસે {count} કર્મચારી પ્રોફાઇલ્સ છે, તો તમે $600 ની નિશ્ચિત ફી ચૂકશો.',
	'payment.calculate.cost.desc.1':
		'ઉદાહરણ તરીકે, જો તમારી પાસે {count} કર્મચારી પ્રોફાઇલ્સ છે, તો તમે પ્રથમ 20 કર્મચારીઓ માટે $600 ની નિશ્ચિત ફી અને બાકીના {diff} કર્મચારીઓ માટે દરેક માટે $30 ચૂકશો.',
	'payment.calculate.cost.desc.2':
		'ઉદાહરણ તરીકે, જો તમારી પાસે {count} કર્મચારી પ્રોફાઇલ્સ છે, તો તમે પ્રથમ 20 કર્મચારીઓ માટે $600 ની નિશ્ચિત ફી, પછીના 30 કર્મચારીઓ માટે દરેક માટે $30 અને બાકીના {diff} કર્મચારીઓ માટે દરેક માટે $20 ચૂકશો.',
	'payment.calculate.cost': 'અંદાજિત ખર્ચ ગણો',
	'payment.calculate.label':
		'સ્લાઇડર ખસેડો અથવા તમારા સંગઠનમાં કર્મચારીઓની સંખ્યા દાખલ કરો:',
	'payment.calculate.desc':
		'માસિક કિંમત નક્કી કરવામાં સહાય કરવા માટે કર્મચારીઓની સંખ્યા ઉમેરો',
	'payment.estimated.monthly': 'અંદાજિત માસિક ખર્ચ:',
	'payment.show.pricingTable': 'કિંમત કોષ્ટક બતાવો',
	'payment.hide.pricingTable': 'કિંમત કોષ્ટક છુપાવો',
	'payment.pricing.table.numEmployee': 'કર્મચારીઓની સંખ્યા',
	'payment.pricing.table.perEmployee': 'દર કર્મચારી દીઠ',
	'payment.pricing.table.flatFee': 'નિશ્ચિત ફી',
	'payment.plan': 'યોજના',
	'payment.plan.desc':
		'તમારી જરૂરિયાત માટે શ્રેષ્ઠ યોજના પસંદ કરો. બંને જોઈએ? એકવાર સેટ અપ કર્યા પછી, તમે બીજું પ્લાન સમાન બિલિંગ ચક્રમાં ઉમેરી શકો છો.',
	payment: 'ચુકવણી',

	manage: 'વ્યવસ્થાપિત કરો',
	'payment.plan.contact': 'વધુ જોઈએ? એન્ટરપ્રાઇઝ સોલ્યુશન માટે વેચાણ ટીમનો સંપર્ક કરો',
	'plans.freeTrial': '14 દિવસ માટે મફત ટ્રાયલ શરૂ કરો',
	'talentGroup.filters.talentGroup': 'પ્રતિભા જૂથ',
	'talentGroup.filters.Bookmark': 'બુકમાર્ક',
	'talentGroup.filters.Shortlist': 'શૉર્ટલિસ્ટ',
	'talentProfile.empty.note': 'કોઈ નોંધ મળી નથી',
	'talentProfile.edit.note': 'નોંધ સંપાદિત કરો',
	'teamCard.talent': '{count, plural, =1 {પ્રતિભા} other {પ્રતિભાઓ}}',
	'teamCardMenu.edit.primary': 'નામ બદલો',
	'teamCardMenu.mask.primary': 'પ્રતિભાને નકાબપوش કરો',
	'teamCardMenu.editattempts.primary': 'પ્રયાસો સંપાદિત કરો',
	'teamCardMenu.editattempts.secondary': 'તમારા પ્રયત્નો બદલો.',
	'teamCardMenu.delete.primary': 'ટીમ કાઢી નાખો',
	'teamCardMenu.edit.secondary': 'તમારી ટીમનું નામ બદલો.',
	'teamCardMenu.mask.secondary':
		'પ્રતિભાને તેમની વ્યક્તિગત ઓળખ માહિતી, જેમ કે નામ, ઈમેલ વગેરે અનામી બનાવવા માટે તક આપો.',
	'teamCardMenu.delete.secondary': 'આ તમારી ટીમને હંમેશા માટે કાઢી નાખશે.',
	'createableSelect.title': 'વિકલ્પ પસંદ કરો અથવા નવું બનાવવા માટે ટાઇપ કરવાનું શરૂ કરો',
	'createableSelect.editWarning': 'આ વિકલ્પ પહેલેથી હાજર છે',
	'createableSelect.deleteOption': 'વિકલ્પ કાઢી નાખો',
	'createableSelect.deleteOption.body': 'શું તમે ખરેખર આ વિકલ્પ દૂર કરવા માંગો છો?',
	'createableSelect.deleteOption.okText': 'દૂર કરો',
	addTalent: 'પ્રતિભાને આમંત્રિત કરો',
	talent: 'પ્રતિભા',
	'addTalent.placeholder': 'આયાત કરવા માટે પ્રતિભા જૂથ પસંદ કરો',
	'addTalent.talentGroup.error.required': 'પ્રતિભા જૂથ ક્ષેત્ર જરૂરી છે',
	'addTalent.bulkSuccess': 'વપરાશકર્તાઓને સફળતાપૂર્વક મોટા પ્રમાણમાં ઉમેર્યા',
	'addTalent.toastSucess': 'વપરાશકર્તાઓને સફળતાપૂર્વક આમંત્રિત કર્યા',
	'addTalent.helperText': 'પ્રતિભા જૂથ પસંદ કરો અને આમંત્રણ મોકલો.',

	'An invite email will automatically be send to the emails you provide':
		'આમંત્રણ ઇમેલ આપેલ ઇમેલ્સ પર આપમેળે મોકલવામાં આવશે',
	'addTalent.uploadCount': 'ઉપયોગકર્તાઓ અપલોડ થયા: {count}',
	'addTalent.remove': 'દૂર કરો',
	'talentGroup.createNew': 'નવું પ્રતિભા જૂથ બનાવો',
	'talentGroup.edit': 'જૂથ સંપાદિત કરો',
	'talentGroup.teamName.error.required': 'ટીમ નામ ક્ષેત્ર આવશ્યક છે',
	'talentGroup.type.error.required': 'પ્રકાર ક્ષેત્ર આવશ્યક છે',
	'talentGroup.color.error.required': 'ટીમ રંગ ક્ષેત્ર આવશ્યક છે',
	'talentGroup.helperText': 'આમંત્રણ ઇમેલ આપેલા ઇમેલ્સ પર આપમેળે મોકલવામાં આવશે',
	'sendEmailReminder.title': 'ઇમેલ રીમાઇન્ડર મોકલો',
	'sendEmailReminder.label': 'ઇમેલ્સ',
	'sendEmailReminder.placeholder': 'બહુવિધ ઇમેલ્સ અવકાશથી અલગ કરીને દાખલ કરો',
	'sendEmailReminder.helperText':
		'તમે ફક્ત તે પ્રતિભાને ઇમેલ રીમાઇન્ડર મોકલી શકો છો જે તમારી પ્રતિભા જૂથમાં હાજર છે',
	'sendEmailReminder.checkboxLabel':
		'તમે જે લોકોએ પડકાર પૂર્ણ કર્યો નથી તેમને ટોળકટી ઇમેલ રીમાઇન્ડર મોકલો',
	'sendEmailReminder.btnLabel': 'મોકલો',
	'sendEmailReminder.error.invalid': 'અયોગ્ય ઇમેલ સરનામું: {emails}',
	'sendEmailReminder.success':
		'સફળતાપૂર્વક {recipientCount} ઇમેલ {recipientCount, plural, =1 {રીમાઇન્ડર} other {રીમાઇન્ડર્સ}} મોકલ્યા',
	'sendEmailReminder.success.unique': 'સફળતાપૂર્વક ઇમેલ રીમાઇન્ડર મોકલ્યો',
	'sendEmailReminderModal.title':
		'તમારી પ્રતિભા જૂથમાં {masked, plural, =1 {{skeleton}} other {{masked}}} ને ઇમેલ રીમાઇન્ડર મોકલો?',
	'sendEmailReminderModal.desc':
		'તમારા દ્વારા "મોકલો" દબાવતા, {masked, plural, = 1 {{skeleton}} other {{masked}}} ને પડકાર પૂર્ણ કરવા માટે ઇમેલ રીમાઇન્ડર મોકલવામાં આવશે.',
	'sendEmailReminder.maskedTalent': 'છુપાયેલ પ્રતિભા',
	'editTalent.label': 'પ્રતિભા જૂથ',
	'editTalent.desc': 'તમારા પ્રતિભા જૂથમાં ફેરફાર કરો',

	'Add or remove talent groups for {masked, plural, =1 {{skeleton}} other {{masked}}}':
		'{masked, plural, =1 {{skeleton}} other {{masked}}} માટે પ્રતિભા જૂથો ઉમેરો અથવા દૂર કરો',
	'editTalent.helper': 'પ્રતિભાઓ એકસાથે કર્મચારી અને ઉમેદવાર જૂથોમાં સમાવી શકતી નથી',
	'challengeSubmission.title': '{value} પડકારો પૂર્ણ કર્યા',
	'challengeSubmission.orderedListSubmission': 'પ્રતિભાની ક્રમબદ્ધ સૂચિ',
	'challengeDetails.desc': 'તે પડકારોની સૂચિ જુઓ જે પ્રતિભાએ જવાબ આપવો પડશે',
	'challengeSubmission.instruction':
		'આ વિકલ્પોને ક્રમમાં ગોઠવો, ટોચ પર સૌથી સંભાવિત અને તળિયે સૌથી ઓછી સંભાવના ધરાવતો',
	'comment.placeholder': 'એક ટિપ્પણી લખો...',
	answer: 'જવાબ',
	'challengeSubmission.prev': 'અંતરવ્યક્તિ જાગરૂકતા',
	'challengeSubmission.next': 'માહિતી શોધવી',
	totalDuration: 'અંદાજિત સમય:',
	challengeDetails: 'પડકાર વિગતો',
	preview: 'પૂર્વદર્શન',
	progress: 'પ્રગતિ',
	mins: 'મિનિટ',
	spent: 'ખર્ચ કર્યો',
	outOf: 'માંથી',
	'legend.consulting': 'પરામર્શ',
	'legend.Series': 'શ્રેણી',
	completed: 'પૂર્ણ થયું',
	incomplete: 'અપૂર્ણ',
	filters: 'ગાળકો',
	viewSubmission: 'સબમિશન જુઓ',
	badges: 'બેજીસ',
	employee: 'કર્મચારી',
	candidate: 'ઉમેદવાર',
	'addedAt.min':
		'{min, plural, =0 {1 મિનિટ પહેલા} =1 {1 મિનિટ પહેલા} other {# મિનિટ પહેલા}} ઉમેર્યું',
	'addedAt.hour': '{hour, plural, =1 {1 કલાક પહેલા} other {# કલાક પહેલા}} ઉમેર્યું',
	'addedAt.day': '{day, plural, =1 {1 દિવસ પહેલા} other {# દિવસ પહેલા}} ઉમેર્યું',
	'addedAt.date': '{date} ના રોજ ઉમેર્યું',
	profile: 'પ્રોફાઇલ',
	roleInterests: 'ભૂમિકા રસ',

	selfReportedSkills: 'સ્વ-અહેવાલ આપેલ કૌશલ્યો',
	roleFunction: 'ભૂમિકા કાર્ય',
	roleLevel: 'ભૂમિકા સ્તર',
	experienceLevel: 'અનુભવ સ્તર',
	education: 'શિક્ષણ',
	softSkillScore: 'નગેટ નરમ કૌશલ્યો સ્કોર',
	challengeSubmission: 'ચેલેન્જ સબમિશન',
	notes: 'નોંધો',
	challengeProgress: 'ચેલેન્જ પ્રગતિ',
	talentGroups: 'પ્રતિભા જૂથો',
	sendEmailReminder: 'ઈમેલ રીમાઇન્ડર મોકલો',
	deleteFormName: '{masked, plural, =1 {{skeleton}} other {{masked}}} કાઢી નાખો?',
	deleteFormDesc:
		'શું તમે ખરેખર {masked, plural, =1 {{skeleton}} other {{masked}}} કાઢી નાખવા માંગો છો? તેની તમામ સામગ્રી કાયમ માટે કાઢી નાખવામાં આવશે અને પુનઃપ્રાપ્ત કરી શકાશે નહીં.',

	editForm: '{value} સંપાદિત કરો',
	editTalentForm: '{masked, plural, =1 {{skeleton}} other {{masked}}} માટે જૂથો સુધારો',
	EditAttempts: 'પ્રયત્નો સંપાદિત કરો {value}',
	edit: 'સંપાદિત કરો',

	talentGroupName: 'પ્રતિભા જૂથનું નામ',
	talentType: 'પ્રતિભા પ્રકાર',

	updatedUser: 'ખાતું સફળતાપૂર્વક અપડેટ થયું.',
	updatedOrg: 'કંપની સફળતાપૂર્વક અપડેટ થઈ.',

	copiedLink: 'લિંક ક્લિપબોર્ડ પર સફળતાપૂર્વક નકલ થઈ',
	publicLink: 'સાર્વજનિક લિંક',
	copyLink: 'લિંક નકલ કરો',
	link: 'લિંક',

	importVia: 'આમદાની દ્વારા',
	importUser: 'વપરાશકર્તા આયાત કરો',

	'importUser.desc': 'નવી પ્રતિભાને આપમેળે પડકાર મોકલવામાં આવશે',

	type: 'પ્રકાર',
	file: 'ફાઈલ',
	groupColor: 'જૂથ રંગ',

	fileDesc:
		'એક ઈમેલ આપમેળે નવી પ્રતિભાને મોકલવામાં આવશે જેથી તેઓ પડકાર પૂર્ણ કરી શકે પછી તમે આયાત કરો.',

	import: 'આયાત',
	uploadFile: 'ફાઇલ અપલોડ કરો',
	loading: 'લોડ કરી રહ્યું છે',

	createOption: '"{value}" બનાવો',
	warning: 'ચેતવણી',
	dashboard: 'ડેશબોર્ડ',
	monitor: 'મોનિટર',

	name: 'નામ',
	email: 'ઈમેલ',
	nuggetScore: 'નગેટ સ્કોર',
	score: 'સ્કોર',

	account: 'ખાતું',
	password: 'પાસવર્ડ',
	firstName: 'પ્રથમ નામ',
	lastName: 'છેલ્લું નામ',

	finish: 'પૂર્ણ કરો',
	newSinceLastLogin: '{count} નવી પ્રતિભા',
	new: 'નવું',

	status: 'સ્થિતિ',
	skills: 'કૌશલ્યો',
	tags: 'ટૅગ્સ',
	location: 'સ્થાન',
	or: 'અથવા',

	challengeCopied: 'ચેલેન્જ લિંક નકલ થઈ',
	linkedin: 'લિંકડઈન',
	emailAddress: 'ઈમેલ સરનામું',
	resume: 'રિઝ્યૂમ',

	sortBy: 'આનુસાર ગોઠવો',
	createdAt: 'બનાવવામાં આવ્યું',
	updatedAt: 'અપડેટ કરવામાં આવ્યું',
	questions: 'પ્રશ્નો',

	'onboarding.skill.with.industry.benchmark': 'ઉદ્યોગ બેન્ચમાર્ક ઉપલબ્ધ છે!',
	'onboarding.skill.without.industry.benchmark': 'ઉદ્યોગ બેન્ચમાર્ક ટૂંક સમયમાં આવશે!',
	'onboarding.show.more.skills': 'વધુ કૌશલ્યો બતાવો!',
	'onboarding.show.less.skills': 'ઓછા કૌશલ્યો બતાવો!',
	'onboarding.help.guide.header.title': 'સહાય માર્ગદર્શિકા',
	'onboarding.help.guide.title': 'સામાન્ય માર્ગદર્શિકા',
	'onboarding.help.guide.btn.label': 'સહાય માર્ગદર્શિકા',

	// Onboarding - challenge selection
	'onboarding.select.challenge.creation.title':
		'તમે કેવી રીતે એક પડકાર પેક બનાવવું તે પસંદ કરો',

	// Onboarding - challenges selection items
	'onboarding.select.role.based.challenges.title': 'ભૂમિકા આધારિત',
	'onboarding.select.role.based.challenges.desc':
		'તમે કેવી રીતે એક પડકાર પેક બનાવવું તે પસંદ કરો',

	'onboarding.select.guided.challenges.title': 'માર્ગદર્શિત',
	'onboarding.select.guided.challenges.desc':
		'એક શ્રેણી પ્રશ્નોનો જવાબ આપો અને અમે તમારા માટે શ્રેષ્ઠ પડકારોની ભલામણ કરીશું',

	'onboarding.select.free.form.title': 'મુક્ત-રુપ',
	'onboarding.select.free.form.desc':
		'આ ખુલ્લા વિકલ્પ છે! અમારા સંપૂર્ણ કૌશલ્ય ગ્રંથાલયમાંથી પસંદ કરો',

	'onboarding.select.entry.level.title': 'કસ્ટમ',
	'onboarding.select.entry.level.desc':
		'આ ખુલ્લા વિકલ્પ છે! અમારા સંપૂર્ણ કૌશલ્ય ગ્રંથાલયમાંથી પસંદ કરો',

	// GUIDED CHALLENGES
	// Onboarding - guided challenges steps
	'onboarding.guided.challenges.step.0': 'પ્રશ્નો',
	'onboarding.guided.challenges.step.1': 'ચેલેન્જ પેક પૂર્વાવલોકન',
	'onboarding.guided.challenges.step.2': 'ટીમ',

	'onboarding.guided.challenges.subStep.0': 'કંપની મૂલ્યો',
	'onboarding.guided.challenges.subStep.1': 'શ્રેષ્ઠ પ્રદર્શન કરનાર',
	'onboarding.guided.challenges.subStep.2': 'સંસ્કૃતિ મેળાપ',
	'onboarding.guided.challenges.subStep.3': 'સંસ્કૃતિ ચેમ્પિયન',

	'onboarding.guided.challenges.skillSelection.title.0':
		'તમારી કંપનીના મૂલ્યો અને ઉદ્દેશ્યો પર વિચાર કરો અને તે નરમ કૌશલ્ય શ્રેણીઓ પસંદ કરો જે તમે સૌથી વધુ સંબંધિત માનો.',

	'onboarding.guided.challenges.skillSelection.description.0':
		'ઓછામાં ઓછી 3 કૌશલ્યો પસંદ કરો',

	/* second step */
	'onboarding.guided.challenges.skillSelection.title.1':
		'હવે, અમે તમારી પસંદ કરેલી શ્રેણીઓમાંના નરમ કૌશલ્યો દર્શાવી રહ્યા છીએ. આમાંથી કયા કૌશલ્યો તમારા માટે સૌથી મહત્વપૂર્ણ છે કે જે એક કર્મચારીને તમારી કંપનીમાં સારી રીતે પ્રદર્શન કરવા માટે હોવા જોઈએ?',

	'onboarding.guided.challenges.skillSelection.description.1':
		'ઓછામાં ઓછી 3 કૌશલ્યો પસંદ કરો',

	/* third step */
	'onboarding.guided.challenges.skillSelection.title.2':
		'ક્યારેક શ્રેષ્ઠ પ્રદર્શન ન કરતા કર્મચારીઓ પણ કંપનીના મૂલ્યોનું પ્રતિનિધિત્વ કરે છે અને તેને સમર્થન આપે છે. તમારી કંપનીમાં સંસ્કૃતિ ચેમ્પિયન બનવા માટે કયા કૌશલ્યો મહત્વપૂર્ણ છે?',

	'onboarding.guided.challenges.skillSelection.description.2':
		'ઓછામાં ઓછી 3 કૌશલ્યો પસંદ કરો',

	/* fourth step */
	'onboarding.guided.challenges.skillSelection.title.3':
		'ચાલો, ટોચના પ્રદર્શન કરનારા અને સંસ્કૃતિ ચેમ્પિયન્સથી થોડું અલગ વિચારીએ. તમારી ટીમના સભ્યો માટે કયા કૌશલ્યો વધુ વિકસિત કરી શકાય તે તમે શું માનો છો?',

	'onboarding.guided.challenges.skillSelection.description.3':
		'ઓછામાં ઓછી 3 કૌશલ્યો પસંદ કરો',

	// Onboarding - guided challenges guides
	'onboarding.guided.challenges.help.guide.title.step.0': 'કંપની મૂલ્યો',
	'onboarding.guided.challenges.help.guide.desc.step.0':
		'જ્યારે તમામ કૌશલ્ય શ્રેણીઓ તમારી કંપનીના મૂલ્યોનો ભાગ હોઈ શકે, ત્યારે તેમની પ્રાથમિકતા નક્કી કરો કે કઈ કંપનીના સૌથી મહત્વપૂર્ણ મૂલ્યોનું સાચું પ્રતિનિધિત્વ કરે છે. જ્યારે તમે આ પડકાર પેક બનાવવાનું લક્ષ્ય નક્કી કરો ત્યારે પણ વિચાર કરો કે કઈ શ્રેણીઓ તમારે પસંદ કરવી છે.',

	'onboarding.guided.challenges.help.guide.title.step.1': 'શ્રેષ્ઠ પ્રદર્શન કરનાર',
	'onboarding.guided.challenges.help.guide.desc.step.1':
		'અમે તમને એ કૌશલ્યો વિશે વિચારવા માંગીએ છીએ જે તમારા કર્મચારીઓને તમારી કંપનીના કાર્યપરિસ્થિતિમાં ઉત્તમ પ્રદર્શન કરવા માટે જરૂરી છે.{linebreak}{linebreak}ઉદાહરણ તરીકે, જો તમારી કંપની ઝડપી કાર્યક્ષમતા ધરાવે છે, તો કયા પ્રકારના કૌશલ્યો કર્મચારીઓને આ વાતાવરણમાં શ્રેષ્ઠ પ્રદર્શન કરવામાં સહાય કરશે?',

	'onboarding.guided.challenges.help.guide.title.step.2': 'સંસ્કૃતિ મેળાપ',
	'onboarding.guided.challenges.help.guide.desc.step.2':
		'અમે તમને તમારી કંપનીના મૂલ્યો વિશે વિચારવા માંગીએ છીએ અને કયા કૌશલ્યો મહત્વપૂર્ણ હશે જે એક કર્મચારીને આ મૂલ્યો સાથે સારી રીતે મેળ ખાવા માટે હોવા જોઈએ.{linebreak}{linebreak}જો આ પહેલાં પસંદ કરેલા કૌશલ્યો સમાન છે, તો તે પણ ઠીક છે! તમારી કંપનીમાં યોગ્ય રીતે ફિટ થવા માટેના તમામ મહત્વપૂર્ણ કૌશલ્યો સૂચિબદ્ધ કરો.',

	'onboarding.guided.challenges.help.guide.title.step.3': 'સંસ્કૃતિ ચેમ્પિયન',
	'onboarding.guided.challenges.help.guide.desc.step.3':
		'સંસ્કૃતિ ચેમ્પિયન એ વ્યક્તિ છે જે તમારી કંપનીના મૂલ્યોને જીવનમાં ઉતારે છે. આ કર્મચારીઓ કામ પર શ્રેષ્ઠ પ્રદર્શન કરતા ન હોય (તેમ છતાં તે શક્ય છે!), પરંતુ તેઓ કંપનીના મૂલ્યો જીવે અને શ્વાસ લે છે.{linebreak}{linebreak}તેઓ વધારાનું કાર્ય કરે છે જેથી કંપનીના મૂલ્યોને પ્રતિબિંબિત કરી શકે અને અન્ય લોકોને આ મૂલ્યો અપનાવવા માટે પ્રોત્સાહિત કરે.',

	'onboarding.guided.challenges.help.guide.title.step.4': 'ચેલેન્જ પેક પૂર્વાવલોકન',
	'onboarding.guided.challenges.help.guide.desc.step.4':
		'પ્રશ્નોના જવાબ પ્રમાણે દર્શાવવામાં આવેલા કૌશલ્યો "આવશ્યક" અને "સારા હશે" તરીકે ગોઠવાયેલા છે. દરેક કૌશલ્ય એક પડકાર રજૂ કરે છે જે વિવિધ પરિસ્થિતિઓથી ભરેલો છે, જેનો જવાબ પડકાર સ્વીકારનારને આપવો પડશે. "ચેલેન્જ પૂર્વાવલોકન" પર ક્લિક કરીને ઉદાહરણ જુઓ.{linebreak}{linebreak}નોંધ: અંદાજીત સમય પહેલાના પડકાર લેનારાઓના વાસ્તવિક ડેટા દ્વારા આપવામાં આવ્યો છે.',

	'onboarding.guided.challenges.help.guide.title.step.5': 'ટીમ',
	'onboarding.guided.challenges.help.guide.desc.step.5':
		'આ છેલ્લું પાનું તમને પરીક્ષણ માટેની પ્રતિભા જૂથનું નામ આપવાની અને વધુ માહિતી ભરવાની પરવાનગી આપે છે જેથી તમારું પડકાર પેક પૂર્ણ થઈ શકે. તમે અહીંથી પડકાર માટે આમંત્રણ મોકલી શકો છો, પરંતુ આ હમણાં જરૂરી નથી - એકવાર ટીમ બની જાય, પછી તમને પડકાર પેક લિંક મળશે અને તમે તેને શેર કરી શકશો.{linebreak}{linebreak}તેઓ વધારાનું કાર્ય કરે છે જેથી કંપનીના મૂલ્યોને પ્રતિબિંબિત કરી શકે અને અન્ય લોકોને આ મૂલ્યો અપનાવવા માટે પ્રોત્સાહિત કરે.',

	// Onboarding - guided challenges (root step)
	/* second step */
	'onboarding.guided.challenges.step.1.title': 'કૌશલ્ય સમીક્ષા',
	'onboarding.guided.challenges.step.1.desc':
		'તમારા કૌશલ્ય ભલામણો અહીં છે. તેમના ક્રમને ગોઠવવા માટે જમણા બાજુના હેન્ડલ્સનો ઉપયોગ કરો અને સૌથી મહત્વપૂર્ણમાંથી ઓછા મહત્વપૂર્ણ સુધી ગોઠવો.',

	/* third step */
	'onboarding.guided.challenges.step.2.title': 'ટીમ વિગતો',

	// ભૂમિકા આધારિત પડકારો
	// ઑનબોર્ડિંગ - ભૂમિકાએ આધારિત પડકારોના પગથિયાં
	'onboarding.role.based.challenges.step.0': 'ભૂમિકા',
	'onboarding.role.based.challenges.step.1': 'પડકારો',
	'onboarding.role.based.challenges.step.2': 'પડકાર પૅક પૂર્વદર્શન',
	'onboarding.role.based.challenges.step.3': 'ટીમ',

	// ઑનબોર્ડિંગ - ભૂમિકાએ આધારિત પડકારો (મુખ્ય પગથિયો)
	/* પહેલું પગથિયું */
	'onboarding.role.based.challenges.step.0.title': 'શરૂઆત કરવા માટે એક ભૂમિકા પસંદ કરો',

	/* બીજું પગથિયું */
	'onboarding.role.based.challenges.step.1.title':
		'તમે પડકાર પૅકમાં સમાવેશ કરવા માંગતા કૌશલ્યો પસંદ કરો',
	'onboarding.role.based.challenges.step.1.description': 'ઓછામાં ઓછી 3 કૌશલ્યો પસંદ કરો',

	/* ત્રીજું પગથિયું */
	'onboarding.role.based.challenges.step.2.title': 'પડકાર પૅક પૂર્વદર્શન',
	'onboarding.role.based.challenges.step.2.desc':
		'આ તમારા સેલ્સ માટેના પડકાર પૅકમાં સમાવિષ્ટ કૌશલ્યોની છેલ્લી ઝલક છે! જમણી બાજુના (=) હેન્ડલ્સનો ઉપયોગ કરીને કૌશલ્યોને સૌથી વધુ (ઉપર) થી ઓછા (નીચે) મહત્વપૂર્ણ ક્રમમાં ગોઠવો. \n\n' +
		'તમે લાલ માઇનસ (-) દબાવીને અનાવશ્યક કૌશલ્યો દૂર પણ કરી શકો છો.',

	/* ચોથું પગથિયું */
	'onboarding.role.based.challenges.step.3.title': 'ટીમની વિગતો',

	'onboarding.role.based.challenges.help.guide.title.step.0': 'ભૂમિકા',
	'onboarding.role.based.challenges.help.guide.desc.step.0':
		'તમારા પરીક્ષણ માટે યોગ્ય લોકોના જૂથને અનુરૂપ શ્રેષ્ઠ ભૂમિકા પસંદ કરો. અમે ઉદ્યોગ ધોરણો પર આધારિત મહત્વપૂર્ણ સોફ્ટ સ્કિલ્સ માટે તમારું પડકાર પેક સૂચવશું. જો તમારી ભૂમિકા ઉપલબ્ધ ન હોય, તો તમે ડૅશબોર્ડ પર પાછા જઈ શકો અને માર્ગદર્શિત ફોર્મેટનો ઉપયોગ કરીને અમને જણાવો કે કઈ ભૂમિકા ઉમેરવી જોઈએ.',

	'onboarding.role.based.challenges.help.guide.title.step.1': 'પડકારો',
	'onboarding.role.based.challenges.help.guide.desc.step.1':
		'ડિફોલ્ટ પડકારો ઉદ્યોગ ધોરણો પર આધારિત છે, જે સફળ થવા માટે જરૂરી મહત્વપૂર્ણ સોફ્ટ સ્કિલ્સ પર કેન્દ્રિત છે. આ તમને મદદ કરવા માટે છે, પરંતુ તમે ફક્ત આ પડકારો સુધી મર્યાદિત નથી. તમે નવા પડકારો ઉમેરી અથવા દૂર કરી શકો. લીલા સંકેત માટે તપાસ કરવાનું ભૂલશો નહીં - તે ઉદ્યોગ સરેરાશની સરખામણીમાં પરીક્ષાર્થીના સ્કોર દર્શાવે છે.',

	'onboarding.role.based.challenges.help.guide.title.step.2': 'પડકાર પેક પૂર્વદર્શન',
	'onboarding.role.based.challenges.help.guide.desc.step.2':
		"પડકાર પેક પૂર્વદર્શન તમને પસંદ કરેલા પડકારો પર છેલ્લો નજર નાખવા માટે મંજૂરી આપે છે. તમે પડકારોની અનુક્રમણિકા બદલી શકો છો અથવા જે પડકારોનો તમે ઉપયોગ ન કરવા માંગતા હો તે દૂર કરી શકો. તમે 'પૂર્વદર્શન પડકાર' બટન પર ક્લિક કરીને ચકાસી શકો છો કે વપરાશકર્તાઓ કઈ પ્રકારની પરીક્ષા આપશે.",

	'onboarding.role.based.challenges.help.guide.title.step.3': 'ટીમ',
	'onboarding.role.based.challenges.help.guide.desc.step.3':
		'આ છેલ્લું પાનું તમને પરીક્ષણ માટે પ્રતિભા જૂથનું નામ આપવામાં અને પડકાર પેક બનાવવાનું અંતિમ રૂપ આપવા માટે જરૂરી માહિતી ભરી શકે છે. તમે આ પૃષ્ઠ પરથી ટીમને આમંત્રિત કરી શકો છો, પરંતુ જો તમે હમણાં આમ ન કરો તો કોઈ સમસ્યા નથી – એકવાર ટીમ બનાવવામાં આવે પછી, તમને પડકાર પેક લિંક મળશે અને તમે તેને શેર કરી શકો.',

	// FREE FORM
	// Onboarding - free-form steps
	'onboarding.free.form.step.0': 'પડકારો',
	'onboarding.free.form.step.1': 'પડકાર પેક પૂર્વદર્શન',
	'onboarding.free.form.step.2': 'ટીમ',

	// Onboarding - free form steps
	/* First step */
	'onboarding.free.form.step.0.title':
		'સ્કિલ્સ પસંદ કરો અને તમારું પોતાનું પડકાર પેક બનાવો',
	'onboarding.free.form.step.0.description': 'ઓછામાં ઓછા 3 સ્કિલ્સ પસંદ કરો',

	/* Second step */
	'onboarding.free.form.step.1.title': 'પડકાર પૂર્વદર્શન',
	'onboarding.free.form.step.1.description':
		'તમારા પડકાર પેકમાં સમાવિષ્ટ સ્કિલ્સની છેલ્લી ઝલક! જમણી બાજુના હેન્ડલ્સ (=) નો ઉપયોગ કરીને સ્કિલ્સને સૌથી મહત્વપૂર્ણ (ટોચ) થી ઓછા મહત્વપૂર્ણ (તળિયે) સુધી ગોઠવો. તમે અનાવશ્યક સ્કિલ્સને લાલ માઇનસ (-) બટન દબાવી દૂર પણ કરી શકો.',

	/* Third step */
	'onboarding.free.form.step.2.title': 'ટીમ વિગતો',

	// Onboarding - free form guides
	'onboarding.free.form.help.guide.title.step.0': 'પડકારો',
	'onboarding.free.form.help.guide.desc.step.0':
		'ડિફોલ્ટ પડકારો ઉદ્યોગ ધોરણો પર આધારિત છે, જે સફળતા માટે મહત્વપૂર્ણ સોફ્ટ સ્કિલ્સ પર ધ્યાન આપે છે. આ તમને મદદ કરવા માટે છે, પરંતુ તમે ફક્ત આ પડકારો સુધી મર્યાદિત નથી. તમે નવા પડકારો ઉમેરી અથવા દૂર કરી શકો. લીલા સંકેત માટે તપાસ કરવાનું ભૂલશો નહીં - તે ઉદ્યોગ સરેરશ સરખામણીમાં પરીક્ષાર્થીના સ્કોર દર્શાવે છે.',

	'onboarding.free.form.help.guide.title.step.1': 'પડકાર પેક પૂર્વદર્શન',
	'onboarding.free.form.help.guide.desc.step.1':
		"પડકાર પેક પૂર્વદર્શન તમને પસંદ કરેલા પડકારો પર છેલ્લી નજર નાખવા માટે મંજૂરી આપે છે. તમે પડકારોની અનુક્રમણિકા બદલી શકો છો અથવા જે પડકારોનો તમે ઉપયોગ ન કરવા માંગતા હો તે દૂર કરી શકો. તમે 'પૂર્વદર્શન પડકાર' બટન પર ક્લિક કરીને ચકાસી શકો કે વપરાશકર્તાઓ કઈ પ્રકારની પરીક્ષા આપશે.",

	'onboarding.free.form.help.guide.title.step.2': 'ટીમ',
	'onboarding.free.form.help.guide.desc.step.2':
		'આ છેલ્લું પાનું તમને પરીક્ષણ માટે પ્રતિભા જૂથનું નામ આપવામાં અને પડકાર પેક બનાવવાનું અંતિમ રૂપ આપવા માટે જરૂરી માહિતી ભરી શકે છે. તમે આ પૃષ્ઠ પરથી ટીમને આમંત્રિત કરી શકો છો, પરંતુ જો તમે હમણાં આમ ન કરો તો કોઈ સમસ્યા નથી – એકવાર ટીમ બનાવવામાં આવે પછી, તમને પડકાર પેક લિંક મળશે અને તમે તેને શેર કરી શકો.',

	// Onboarding - EntryForm
	'onboarding.entry.level.step.0': 'મૂલ્યાંકન વિગતો',
	'onboarding.entry.level.step.1': 'પ્રશ્નો પસંદ કરો',
	'onboarding.entry.level.step.2': 'ટીમ',

	// Team onboarding
	'teams.onboarding.title': 'નવી ટીમ બનાવો',
	'teams.onboarding.learnMore': 'વધુ જાણો.',

	// Team onboarding - objective
	'teams.onboarding.objective.restricted.0': 'સીમિત ઉદ્દેશ્ય',
	'teams.onboarding.objective.restricted.1':
		'આ સુવિધાનો ઉપયોગ કરવા માટે હાયરિંગ પ્લાન જરૂરી છે.',
	'teams.onboarding.objective.restricted.2':
		'આ સુવિધાનો ઉપયોગ કરવા માટે બેન્ચમાર્કિંગ પ્લાન જરૂરી છે.',

	'teams.onboarding.objective.stepTitle': 'ઉદ્દેશ્ય',
	'teams.onboarding.objective.nyomiMessage':
		'nugget.ai સિમ્યુલેશન આધારિત મૂલ્યાંકન (જેને અમે nugget.ai ચેલેન્જીસ કહે છે) નો ઉપયોગ કરે છે, જે ઉમેદવારો અને કર્મચારીઓની કૌશલ્ય ક્ષમતાઓ માપવામાં મદદ કરે છે. આ સાધનો તમને શ્રેષ્ઠ પ્રતિભા નિમવા અથવા તમારા વર્તમાન કર્મચારીઓની કૌશલ્ય ક્ષમતાઓ માપવામાં મદદ કરી શકે છે.',

	'teams.onboarding.objective.title': 'કેન્દ્રિત થવા માટે એક ઉદ્દેશ્ય પસંદ કરો',
	'teams.onboarding.objective.description':
		'ઉદ્દેશ્ય નક્કી કરશે કે તમારી કૌશલ્ય ભલામણ કેવી રીતે કરવામાં આવશે.',

	'teams.onboarding.objective.learnMore':
		'nugget.ai સિમ્યુલેશન આધારિત મૂલ્યાંકનોનો ઉપયોગ કરે છે, જેને “ચેલેન્જીસ” તરીકે ઓળખવામાં આવે છે, જે ઉમેદવારો અને કર્મચારીઓની કૌશલ્ય ક્ષમતાઓ માપવામાં મદદ કરે છે. આ સાધનો તમને શ્રેષ્ઠ પ્રતિભા નિમવામાં અથવા તમારા વર્તમાન કર્મચારીઓની કૌશલ્ય ક્ષમતાઓ માપવામાં મદદ કરી શકે છે. \n\nતમે પ્રારંભ કરવા માટે માત્ર એક જ ઉદ્દેશ્ય પસંદ કરી શકો છો, પરંતુ એકવાર તમારી ટીમ સક્રિય થયા પછી, હાયરિંગ અને બેન્ચમાર્કિંગ બંને એકસાથે ચલાવવા માટે જૂથો બનાવવામાં કોઇ અડચણ નથી.',

	// team onboarding - objective -> choices
	'teams.onboarding.objective.hiring.tooltip':
		'અમે તમને તમારી પ્રતિભા પૂલના કૌશલ્ય માપવામાં મદદ કરી શકીએ, જે તમને શ્રેષ્ઠ ઉમેદવાર પસંદ કરવામાં મદદ કરશે.',

	'teams.onboarding.objective.benchmarking.tooltip':
		'અમે તમારી કંપનીમાં કર્મચારીઓની કૌશલ્ય ક્ષમતાઓ માપવામાં પણ મદદ કરી શકીએ છીએ, જે તમારા કર્મચારીઓની શક્તિશાળી અને સુધારાની જરૂરિયાત ધરાવતા ક્ષેત્રો ઓળખવામાં મદદ કરશે. તમે વ્યક્તિગત કર્મચારીઓ, ટીમો, તેમજ આખી કંપનીના કૌશલ્યોની સમીક્ષા કરી શકો છો, અને જાણી શકો છો કે તમારી કંપનીમાં લોકોને અનન્ય બનાવે છે.',

	// team onboarding - skill identification
	'teams.onboarding.skillIdentification.stepTitle': 'વિગતો',

	'teams.onboarding.skillIdentification.nyomiMessage.initial':
		'આ nugget.ai ચેલેન્જ પસંદગી પ્રક્રિયાની શરૂઆત છે! તમને કુલ ચાર પ્રશ્નો પૂછવામાં આવશે <bold> જે અમને સમજવામાં મદદ કરશે </bold> કે તમારી કંપનીમાં કયા સોફ્ટ સ્કિલ્સ કિંમતી, પ્રોત્સાહિત અને મજબૂત બનાવવામાં આવે છે.',

	'teams.onboarding.skillIdentification.title.0.tooltip':
		'સોફ્ટ સ્કિલ્સ એ પરિવર્તનશીલ અને અનુકૂલનશીલ કૌશલ્યો છે, જે અસરકારક નોકરી પ્રદર્શન માટે જરૂરી હોય છે, જેમ કે સંચાર અને સમય વ્યવસ્થાપન. તેઓ હાર્ડ સ્કિલ્સ કરતાં અલગ છે, જે નોકરી માટે જરૂરી તકનીકી કૌશલ્યો છે.',

	'teams.onboarding.skillIdentification.description.0':
		'નીચે nugget.ai સોફ્ટ સ્કિલ્સ શ્રેણીઓ આપવામાં આવી છે. આ વિશે વિચારવા માટે તમારું સમય લો, કારણ કે સચોટ સમજ મેળવવી મહત્વપૂર્ણ છે કે આ નોકરી માટે સારો ઉમેદવાર કોણ હોઈ શકે. તમને આગળના કેટલાક પ્રશ્નોમાં વધુ ચોક્કસ સોફ્ટ સ્કિલ્સ ઓળખવાની તક મળશે. કૃપા કરીને બધાં લાગુ પડતા વિકલ્પો પસંદ કરો.',

	'teams.onboarding.skillIdentification.title.1':
		'હવે, અમે તમારી પસંદ કરેલી શ્રેણીઓની અંદરના સોફ્ટ સ્કિલ્સ દર્શાવી રહ્યા છીએ. કયા કૌશલ્યો કર્મચારી માટે આ ભૂમિકા માટે ઉત્તમ બનાવવા જરૂરી છે?',

	'teams.onboarding.skillIdentification.description.1':
		'કૃપા કરીને બધાં લાગુ પડતા વિકલ્પો પસંદ કરો.',

	// team onboarding - skill identification - benchmarking
	'teams.onboarding.skillIdentification.benchmarking.nyomiMessage.succeeding':
		'તમે છેલ્લે ઓળખેલી કૌશલ્ય શ્રેણીઓના આધારે, અમે હવે તમને એવા ચોક્કસ સોફ્ટ સ્કિલ્સ ઓળખવામાં મદદ માટે પ્રશ્નો પૂછશું, જે તમારી કંપની માટે સંબંધિત છે.',

	// first step
	'teams.onboarding.skillIdentification.benchmarking.modalTitle.0': 'કંપની મૂલ્યો',

	'teams.onboarding.skillIdentification.benchmarking.title.0':
		'તમારી કંપનીના મૂલ્યો અને ઉદ્દેશ્યો પર વિચાર કરો, અને તે સોફ્ટ સ્કિલ્સ શ્રેણીઓ પસંદ કરો, જે તમે સૌથી વધુ સંબંધિત માનો છો.',

	'teams.onboarding.skillIdentification.benchmarking.description.0':
		'કૃપા કરીને બધાં લાગુ પડતા વિકલ્પો પસંદ કરો.',

	'teams.onboarding.skillIdentification.benchmarking.learnMore.0':
		'આ nugget.ai ચેલેન્જ પસંદગી પ્રક્રિયાની શરૂઆત છે! તમને કુલ ચાર પ્રશ્નો પૂછવામાં આવશે, જે અમને સમજવામાં મદદ કરશે કે કયા સોફ્ટ સ્કિલ્સ તમારી કંપનીમાં કિંમતી, પ્રોત્સાહિત અને મજબૂત બનાવવામાં આવે છે.\n\nસોફ્ટ સ્કિલ્સ એ પરિવર્તનશીલ અને અનુકૂલનશીલ કૌશલ્યો છે, જે અસરકારક નોકરી પ્રદર્શન માટે જરૂરી હોય છે, જેમ કે સંચાર અને સમય વ્યવસ્થાપન. તેઓ હાર્ડ સ્કિલ્સ કરતાં અલગ છે, જે નોકરી માટે જરૂરી તકનીકી કૌશલ્યો છે.\n\nનીચે nugget.ai સોફ્ટ સ્કિલ્સ શ્રેણીઓ આપવામાં આવી છે. આ વિશે વિચારવા માટે તમારું સમય લો, કારણ કે સચોટ સમજ મેળવવી મહત્વપૂર્ણ છે કે તમારી કંપનીને શું અનન્ય બનાવે છે!',

	// second step
	'teams.onboarding.skillIdentification.benchmarking.modalTitle.1': 'ઉત્તમ કર્મચારી',

	'teams.onboarding.skillIdentification.benchmarking.title.1':
		'હવે, અમે તમારી પસંદ કરેલી શ્રેણીઓની અંદરના સોફ્ટ સ્કિલ્સ દર્શાવી રહ્યા છીએ. તમારી કંપનીમાં એક કર્મચારીને શ્રેષ્ઠ પ્રદર્શન કરવા માટે કયા સોફ્ટ સ્કિલ્સ સૌથી મહત્વપૂર્ણ હશે?',

	'teams.onboarding.skillIdentification.benchmarking.description.1':
		'કૃપા કરીને બધાં લાગુ પડતા વિકલ્પો પસંદ કરો.',

	'teams.onboarding.skillIdentification.benchmarking.learnMore.1':
		'અમે તમારી પાસે એ વિચારીને જવાબ આપવા માંગીએ છીએ કે તમારા કર્મચારીઓની શ્રેષ્ઠ કામગીરી માટે કયા કૌશલ્યો જરૂરી છે.{linebreak}{linebreak} ઉદાહરણ તરીકે, જો તમારી કંપની ઝડપી ગતિવાળી કાર્યસ્થળની સંસ્કૃતિ પ્રોત્સાહિત કરે છે, તો કર્મચારીઓ માટે કયા કૌશલ્યો ઉપયોગી સાબિત થશે?',

	// second step sub-steps
	'teams.onboarding.skillIdentification.benchmarking.sub.0': 'કંપની મૂલ્યો',
	'teams.onboarding.skillIdentification.benchmarking.sub.1': 'ઉત્તમ કર્મચારી',
	'teams.onboarding.skillIdentification.benchmarking.sub.2': 'સંસ્કૃતિ ચેમ્પિયન',
	'teams.onboarding.skillIdentification.benchmarking.sub.3': 'કૌશલ્ય ખામી',

	// third step
	'teams.onboarding.skillIdentification.benchmarking.modalTitle.2': 'સંસ્કૃતિ ચેમ્પિયન',

	'teams.onboarding.skillIdentification.benchmarking.title.2':
		'ક્યારેક શ્રેષ્ઠ પ્રદર્શન ન કરનારા કર્મચારી પણ કંપનીના મૂલ્યોનું પ્રતિનિધિત્વ કરતા હોય છે. સંસ્કૃતિ ચેમ્પિયન માટે કયા કૌશલ્યો મહત્વપૂર્ણ છે?',

	'teams.onboarding.skillIdentification.benchmarking.description.2':
		'કૃપા કરીને બધાં લાગુ પડતા વિકલ્પો પસંદ કરો.',

	'teams.onboarding.skillIdentification.benchmarking.learnMore.2':
		'સંસ્કૃતિ ચેમ્પિયન એ છે જે કંપનીના મૂલ્યોને પોતાના વ્યક્તિત્વ દ્વારા દર્શાવે છે. આ કર્મચારીઓ શ્રેષ્ઠ પ્રદર્શન ન કરતા હોવા છતાં (પરંતુ તે શક્ય છે!) તેઓ કંપનીના મૂલ્યોને જીવંત રાખે છે.\n\nતેઓ કંપનીના મૂલ્યોને પ્રતિબિંબિત અને પ્રોત્સાહિત કરવા માટે પ્રયત્ન કરે છે અને અન્ય લોકોને પણ તે અપનાવવા પ્રોત્સાહિત કરે છે.',

	// fourth step
	'teams.onboarding.skillIdentification.benchmarking.modalTitle.3': 'કૌશલ્ય ખામી',

	'teams.onboarding.skillIdentification.benchmarking.title.3':
		'આપણું ધ્યાન શ્રેષ્ઠ પ્રદર્શકો અને સંસ્કૃતિ ચેમ્પિયન્સ પરથી થોડું બદલીયે. તમારા મતે, તમારી ટીમમાં કયા કૌશલ્યો વધુ વિકસાવી શકાય?',

	'teams.onboarding.skillIdentification.benchmarking.description.3':
		'કૃપા કરીને બધાં લાગુ પડતા વિકલ્પો પસંદ કરો.',

	// team onboarding - skill identification - benchmarking
	'teams.onboarding.skillIdentification.benchmarking.learnMore.3':
		'હવે કે જ્યારે આપણે એ કુશળતાઓ કવર કરી લીધી છે જે તમારાં શ્રેષ્ઠ પ્રદર્શક કર્મચારીઓ અને સંસ્કૃતિ ચેમ્પિયન્સ માટે જરૂરી છે, ચાલો એ કુશળતાઓ પર ધ્યાન દઈએ કે જે તમારી ટીમમાં વધુ સુધારી અને વિકસાવી શકાય.',

	'teams.onboarding.skillIdentification.benchmarking.title.1.tooltip':
		'અમે તમને વિચારવા માટે કહીશું કે તમારી કંપનીના કામકાજી વાતાવરણમાં એક કર્મચારી માટે કઈ કુશળતાઓ જરૂરી છે.{linebreak}{linebreak}ઉદાહરણ તરીકે, જો તમારી કંપની ઝડપી ગતિએ કાર્ય કરે છે, તો એવી કઈ કુશળતાઓ છે જે કર્મચારીઓને આ પરિસ્થિતિમાં શ્રેષ્ઠ પ્રદર્શન કરવા માટે મદદ કરશે?',

	'teams.onboarding.skillIdentification.benchmarking.title.2.tooltip':
		'અમે તમને વિચારો માટે કહીશું કે તમારી કંપનીના મૂલ્યો શું છે અને એક કર્મચારી માટે કઈ કુશળતાઓ મહત્વપૂર્ણ છે જેથી તેઓ તમારી કંપનીના મૂલ્યો માટે યોગ્ય ગણાય.',

	'teams.onboarding.skillIdentification.benchmarking.title.3.tooltip':
		'સંસ્કૃતિ ચેમ્પિયન એ વ્યક્તિ છે જે તમારી કંપનીના મૂલ્યોને સમર્પિત રીતે અનુસરે છે. આ કર્મચારીઓ આવશ્યક નથી કે કામમાં શ્રેષ્ઠ પ્રદર્શન કરે (ભલે તેઓ કરી શકે!), પણ તેઓ કંપનીના મૂલ્યોને જીવંત રાખે છે.{linebreak}{linebreak}તેઓ કંપનીના મૂલ્યોને પ્રતિબિંબિત અને પ્રોત્સાહિત કરવા પ્રયત્ન કરે છે અને અન્ય લોકોને પણ આ મૂલ્યો અપનાવા માટે પ્રેરિત કરે છે.',

	// team onboarding - skill identification - hiring
	'teams.onboarding.skillIdentification.hiring.nyomiMessage.succeeding':
		'તમારા અગાઉના જવાબો પરથી પસંદ કરેલા કુશળતા કેટેગરીઝનો ઉપયોગ કરીને, અમે હવે તમને એવા સોફ્ટ સ્કિલ્સ ઓળખવામાં મદદ કરીશું જે નોકરી માટે મહત્વપૂર્ણ છે.',

	// First step
	'teams.onboarding.skillIdentification.hiring.modalTitle.0': 'ઉમેદવારની સોફ્ટ સ્કિલ્સ',

	'teams.onboarding.skillIdentification.hiring.title.0':
		'તમારા આદર્શ ઉમેદવાર માટે નીચેની સોફ્ટ સ્કિલ્સ કેટેગરીઝમાંથી કઈ તમે શોધી રહ્યા છો?',

	'teams.onboarding.skillIdentification.hiring.description.0':
		'બધી લાગુ પડે તેવી પસંદ કરો.',

	'teams.onboarding.skillIdentification.hiring.learnMore.0':
		'આ nugget.ai ચેલેન્જ સિલેક્શન પ્રોસેસની શરૂઆત છે! અમે તમને કુલ ચાર પ્રશ્નો પૂછશું જે અમને એ સમજવામાં મદદ કરશે કે આ ભૂમિકા માટે કઈ સોફ્ટ સ્કિલ્સ જરૂરી છે.\n\nસોફ્ટ સ્કિલ્સ એ પરિવર્તનશીલ અને અનુકૂળ કુશળતાઓ છે જે એક ઉમેદવારને અસરકારક રીતે કામ કરવા માટે મદદ કરે છે, જેમ કે સંચાર અને સમય વ્યવસ્થાપન. તે હાર્ડ સ્કિલ્સ કરતા જુદી છે, જે ખાસ કરીને નોકરી માટે જરૂરી તકનીકી કુશળતાઓ છે.',

	'teams.onboarding.skillIdentification.hiring.modalTitle.1': 'આવશ્યક કુશળતાઓ',

	'teams.onboarding.skillIdentification.hiring.title.1':
		'હવે, અમે તમને તમારી પસંદ કરેલી કેટેગરીઝમાંની સોફ્ટ સ્કિલ્સ બતાવી રહ્યા છીએ. તમારાં દ્રષ્ટિકોણથી, આ ભૂમિકામાં સફળ થવા માટે કઈ કુશળતાઓ જરૂરી છે?',

	'teams.onboarding.skillIdentification.hiring.description.1':
		'બધી લાગુ પડે તેવી પસંદ કરો.',

	'teams.onboarding.skillIdentification.hiring.learnMore.1':
		'તમારા અગાઉના જવાબો પરથી પસંદ કરેલા કુશળતા કેટેગરીઝનો ઉપયોગ કરીને, અમે હવે તમને એવા સોફ્ટ સ્કિલ્સ ઓળખવામાં મદદ કરીશું જે નોકરી માટે મહત્વપૂર્ણ છે.\n\nઅમે તમને એ વિચારો માટે કહીશું કે આ ભૂમિકા માટે એક કર્મચારી માટે કઈ કુશળતાઓ જરૂરી છે.\n\nઆ કુશળતાઓ એવી હોવી જોઈએ જે કર્મચારી પાસે પહેલેથી જ હોય જેથી તેઓ નોકરીના પ્રથમ દિવસે જ સારી કામગીરી કરી શકે.',

	// Second step sub-steps

	'teams.onboarding.skillIdentification.hiring.sub.0': 'ઉમેદવારની સોફ્ટ સ્કિલ્સ',
	'teams.onboarding.skillIdentification.hiring.sub.1': 'આવશ્યક કુશળતાઓ',
	'teams.onboarding.skillIdentification.hiring.sub.2': 'પ્રશિક્ષિત કરી શકાય તેવી કુશળતાઓ',
	'teams.onboarding.skillIdentification.hiring.sub.3': 'કંપની ફિટ',

	// Third step
	'teams.onboarding.skillIdentification.hiring.modalTitle.2':
		'પ્રશિક્ષિત કરી શકાય તેવી કુશળતાઓ',

	'teams.onboarding.skillIdentification.hiring.title.2':
		'આમાંથી કઈ કુશળતાઓ તમને મહત્વપૂર્ણ લાગે છે, પણ ભૂમિકાની જરૂરિયાત નથી અથવા એવી છે કે જે કાર્યસ્થળ પર તાલીમ દ્વારા વિકસાવી શકાય?',

	'teams.onboarding.skillIdentification.hiring.description.2':
		'બધી લાગુ પડે તેવી પસંદ કરો.',

	'teams.onboarding.skillIdentification.hiring.learnMore.2':
		'બધી તે કુશળતાઓ પસંદ કરો જે કાર્યસ્થળ પર શીખવાઈ શકે છે અથવા જે માટે તમે વધારાની તાલીમ પ્રદાન કરવા અથવા ભલામણ કરવા તૈયાર છો.',

	'teams.onboarding.skillIdentification.hiring.modalTitle.3': 'કંપની ફિટ',

	'teams.onboarding.skillIdentification.hiring.title.3':
		'અમે અત્યાર સુધી તે કુશળતાઓને આવરી લીધી છે જે ખાસ કરીને તમારી ભાડે રાખવા માટેની ભૂમિકા માટે જરૂરી છે. હવે, તમારી કંપની વ્યાપક રીતે વિચારો. તમારી કંપનીના મૂલ્યો અને સંસ્કૃતિને ધ્યાનમાં રાખીને, તમે તમારા આદર્શ ઉમેદવાર પાસે કઈ કુશળતાઓ હોય તે ઇચ્છો છો?',

	'teams.onboarding.skillIdentification.hiring.description.3': 'બધું લાગુ પડે તે પસંદ કરો.',

	'teams.onboarding.skillIdentification.hiring.learnMore.3':
		'ભૂમિકા માટે જરૂરી કુશળતાઓ ઉપરાંત, આ તે કુશળતાઓ છે જે સામાન્ય રીતે તમારી કંપનીમાં મૂલ્યવાન માનવામાં આવે છે.\n\nજો આ કુશળતાઓ તે જ છે જે તમે અગાઉ પસંદ કરી છે, તો તે ચિંતાનો વિષય નથી! કૃપા કરીને તે કુશળતાઓ હાઇલાઇટ કરો જે વ્યક્તિને તમારી કંપનીમાં સારી રીતે ફિટ થવા માટે મહત્વપૂર્ણ છે.',

	'teams.onboarding.skillIdentification.hiring.title.1.tooltip':
		'અમે તમને વિચારવા માટે કહીશું કે આ નોકરીમાં એક કર્મચારી માટે કઈ કુશળતાઓ મહત્વપૂર્ણ છે.{linebreak}{linebreak}આ કુશળતાઓ એવી હોવી જોઈએ કે જે કર્મચારી પાસે પહેલાથી જ હોય જેથી તેઓ નોકરીના પ્રથમ દિવસે જ સારી રીતે કામગીરી કરી શકે.',

	'teams.onboarding.skillIdentification.hiring.title.2.tooltip':
		'આ કુશળતાઓ એવી છે કે જે અથવા તો કામ દરમિયાન શીખવાઈ શકે છે અથવા તો તમે પ્રદાન કરવા માટે તૈયાર છો.',

	'teams.onboarding.skillIdentification.hiring.title.3.tooltip':
		'આ કુશળતાઓ એવી છે જે કર્મચારી રોજિંદા કામમાં સતત ઉપયોગ કરશે, એટલે કે નવી ભરતી કરતી વખતે તેની ગંભીરતા વધારે છે.{linebreak}{linebreak}ઉદાહરણ તરીકે, જો ભૂમિકા એવી છે કે જેમાં વ્યક્તિએ અનિશ્ચિતતા વાળા વાતાવરણમાં સતત કામ કરવું પડે, તો "અસ્પષ્ટતા માટે સહનશીલતા" એ મહત્ત્વપૂર્ણ કુશળતા બને છે!',

	// team onboarding - skill importance
	'teams.onboarding.skillImportance.stepTitle': 'કુશળતાઓ',

	'teams.onboarding.skillImportance.nyomiMessage':
		'તમારા તમામ પ્રશ્નોના જવાબ આપવા બદલ આભાર! અમે અગાઉ તમે ઓળખી કઢેલી તમામ સોફ્ટ સ્કિલ્સને મહત્વના ક્રમમાં ગોઠવી છે. અમે "અત્યંત જરૂરી" અને "સરસ હોય" એવી કુશળતાઓને અલગ કરી છે, જે આ ચેલેન્જ માટે ઉપયોગ થશે.',

	'teams.onboarding.skillImportance.title': 'કુશળતા સમીક્ષા',

	'teams.onboarding.skillImportance.modalTitle': 'કુશળતા સમીક્ષા',

	'teams.onboarding.skillImportance.learnMore':
		'તમારા આપેલા જવાબો પરથી આ કુશળતાઓ પસંદ કરવામાં આવી છે. અમારી સિસ્ટમ તમારી જરૂરિયાતો અનુસાર શ્રેષ્ઠ કુશળતાઓ પસંદ કરવા માટે તૈયાર કરવામાં આવી છે. જ્યારે અમે કુશળતાઓની ભલામણ કરીએ, ત્યારે તેને "અત્યંત જરૂરી" અને "સરસ હોય" એવા જૂથોમાં વિભાજિત કરીએ છીએ. દરેક કુશળતા એક ચેલેન્જ તરીકે રહેશે, જેમાં ઉમેદવારોને જવાબ આપવા પડશે.\n\nનોંધ: અંદાજીત સમય એ આપણા સાયન્સ ટીમ દ્વારા કરવામાં આવેલા પ્રયોગો પરથી મળેલો ડેટા છે. દરેક ચેલેન્જમાં જુદા-જુદા સમય મર્યાદા હોય છે. અમે 3-5 ચેલેન્જ પસંદ કરવાનું ભલામણ કરીએ છીએ જેથી ઉમેદવારો માટે જવાબ આપવું સરળ બને.',

	'teams.onboarding.skillImportance.description':
		'તમારા માટે ભલામણ કરેલી કુશળતાઓ અહીં છે. મહત્વ પ્રમાણે ગોઠવવા માટે સજ્જો ઉપયોગ કરો.',

	'teams.onboarding.skillImportance.totalChallengeTime.title': 'અંદાજીત કુલ સમય:',

	'teams.onboarding.skillImportance.skillsRequired':
		'ઓછામાં ઓછી {count} કુશળતાઓ જરૂરી છે. પાછા જાઓ અને તમારી પસંદગીઓ સંપાદિત કરો.',

	'teams.onboarding.skillImportance.totalChallengeTime.title.tooltip':
		'કામ માટે સંબંધિત તમામ કુશળતાઓ ધ્યાનમાં લઇ, અમે અંદાજિત સમય નોંધ્યો છે કે ઉમેદવારને સંપૂર્ણ ચેલેન્જ પૂર્ણ કરવા માટે કેટલો સમય લાગશે.',

	'teams.onboarding.skillImportance.totalChallengeTime.description':
		'દરેક કુશળતા માટે એક અંદાજિત સમય હોય છે કે કર્મચારી માટે તેને પૂર્ણ કરવામાં કેટલો સમય લાગશે.',

	'teams.onboarding.skillImportance.mustHaveSkills.title': 'અત્યંત જરૂરી કુશળતાઓ',

	'teams.onboarding.skillImportance.mustHaveSkills.description':
		'સફળતાપૂર્વક નોકરી કરવા માટે જરૂરી કુશળતાઓ.',

	'teams.onboarding.skillImportance.niceToHaveSkills.title': 'સરસ હોય તેવી કુશળતાઓ',

	'teams.onboarding.skillImportance.niceToHaveSkills.description':
		'આ કુશળતાઓ તમારી કંપનીના કર્મચારીઓ પાસે હોવી આદર્શ છે, પણ તે જરૂરી નથી.',

	// team onboarding - team details
	'teams.onboarding.teamDetails.stepTitle': 'ટીમ',

	'teams.onboarding.teamDetails.nyomiMessage':
		'તમારી ચેલેન્જ બનાવવામાં આવી ગઈ છે! હવે તમારી ટીમ બનાવો અને હું તમને ચેલેન્જ મોકલીશ.',

	'teams.onboarding.teamDetails.title': 'ટીમ વિગતો',

	'teams.onboarding.teamDetails.description':
		'કૃપા કરીને નીચે તમારી કંપનીના કર્મચારીઓ માટેની માહિતી ભરો.',

	'teams.onboarding.teamDetails.teamName': 'ટીમનું નામ',

	'teams.onboarding.teamDetails.maskChallenge': 'ચેલેન્જ છુપાવો',

	'teams.onboarding.teamDetails.maskChallenge.description':
		'હા પસંદ કરવાથી, ચેલેન્જ લેતા કોઈપણ વ્યક્તિને તેમની ઓળખ છુપાવવાની છૂટ મળશે, જેથી તેઓ પોતાનું નામ અને ઈમેલ છુપાવી શકે.',

	'teams.onboarding.teamDetails.maskChallenge.tooltip':
		'આથી લોકો વધુ આરામદાયક અનુભવે છે અને અભ્યાસો દર્શાવે છે કે તે તમારા ચેલેન્જ પૂર્ણ થવાની દરને 50% સુધી વધારી શકે છે.',

	'teams.onboarding.teamDetails.talentGroupDetails': 'પ્રતિભા જૂથની વિગતો',

	'teams.onboarding.teamDetails.talentGroupDetails.description':
		'તમે આ ટીમની અંદર ઉમેદવારોના આ જૂથને ઓળખવા માટે એક જૂથ બનાવી શકો છો.',

	'teams.onboarding.teamDetails.talentGroupDetails.talentType.tooltip':
		'પ્રતિભા પ્રકારનો ઉપયોગ કર્મચારીઓ અને ઉમેદવારો વચ્ચે ભેદ ઉભા કરવા માટે થાય છે.',

	'teams.onboarding.teamDetails.talentGroupDetails.talentColor': 'પ્રતિભા રંગ',

	'teams.onboarding.teamDetails.talentGroupDetails.inviteTeammates': 'પ્રતિભા આમંત્રિત કરો',

	'teams.onboarding.teamDetails.talentGroupDetails.inviteTeammates.description':
		'તેમને ચેલેન્જ લિંક મોકલવા માટે ઈમેલ્સ દાખલ કરો. તમે હંમેશા પુનઃમોકલી શકો છો અથવા પછીથી મોકલી શકો છો.',

	all: 'બધું',
	faq: 'એફએક્યૂ',
	yes: 'હાં',
	no: 'ના',
	multiEmailFieldPlaceholder: 'એક ઈમેઇલ લખો અને મોકલવા માટે એન્ટર દબાવો અથવા બીજું ઉમેરો',
	browseFiles: 'ફાઇલો બ્રાઉઝ કરો',
	fileFormat: 'ફાઇલ ફોર્મેટ',
	maximumSize: 'મહત્તમ માપ',

	// tour
	'tour.title': 'એક પ્રવાસ લો!',
	'tour.naomi': 'હાય, હું નઓમી છું, તમારી એઆઈ સહાયક, અહીં {linebreak}મદદ માટે છું!',
	'tour.description': 'મદદ જોઈએ છે? અમારી સહાય માર્ગદર્શિકાઓ શોધો.',
	'tour.seeVideoDemo': 'વિડિયો ડેમો જુઓ',
	'tour.viewDemoData': 'ડેમો ડેટા',
	'tour.learnAboutOurScience': 'અમારા વિજ્ઞાન વિશે જાણો',
	'tour.closingMessage':
		'ચિંતા ન કરો, તમે ટોચની સંચાલન પેનલમાંથી હજુ પણ માર્ગદર્શિકા લિંક્સ શોધી શકો છો.',

	// tours
	'tours.team.addTalent': 'પ્રતિભાને આમંત્રિત કરો',
	'tours.team.addTalent.desc':
		'પ્રતિભા ઉમેરવા માટે અહીં ક્લિક કરો. તમે CSV ફાઇલ આયાત કરી શકો છો અથવા ઑફલાઇન મોકલવા માટે લિંક જનરેટ કરી શકો છો.',

	'tours.team.groupCard': 'પ્રતિભા જૂથ કાર્ડ',
	'tours.team.groupCard.desc':
		'તમારી પ્રતિભાને જૂથમાં ગોઠવો. અમે તમારા માટે પહેલું જૂથ બનાવી દીધું છે.',

	'tours.team.addTalentGroup': 'પ્રતિભા જૂથ ઉમેરો',
	'tours.team.addTalentGroup.desc': 'નવું પ્રતિભા જૂથ બનાવવા માટે અહીં ક્લિક કરો.',

	'tours.team.talent': 'પ્રતિભા',
	'tours.team.talent.desc':
		'તમારા ટીમ લિંક દ્વારા આયાત અથવા આમંત્રિત કરેલ પ્રતિભા અહીં દેખાશે.',

	'tours.team.talentDynamic': 'પ્રતિભા ગતિશીલતા',
	'tours.team.talentDynamic.desc':
		'જ્યારે પ્રતિભા ચેલેન્જો પૂર્ણ કરશે, ત્યારે તમે તેમની કુશળતાઓ જોવાની અને અન્ય સાથે તેમની તુલના કરવાની ક્ષમતા મેળવી શકશો.',

	'tours.team.finish': 'સમાપ્ત કરો',

	'Welcome back, John!': 'જોન, ફરી આવકાર!',
	'Recent Assessment': 'તાજેતરનું મૂલ્યાંકન',
	'Time Taken': 'લિધેલો સમય',
	'Exam Taken On': 'આપેલ પરીક્ષા',
	Today: 'આજે',
	'Last 7 Days': 'છેલ્લાં ૭ દિવસ',
	'Last 30 Days': 'છેલ્લાં ૩૦ દિવસ',
	Team: 'ટીમ',
	Group: 'સમૂહ',
	'All Attempts': 'બધા પ્રયત્નો',
	Live: 'પ્રસારિત',
	Finished: 'પૂર્ણ',
	Terminated: 'બંધ કરેલ',
	'Here s Asseessment Overview': 'અહીં મૂલ્યાંકનનો સારાંશ છે',
	'Section Name': 'વિભાગનું નામ',
	'Add New Section': 'નવું વિભાગ ઉમેરો',
	'No of Questions': 'પ્રશ્નોની સંખ્યા',
	'Sub-Section Name': 'ઉપવિભાગનું નામ',
	'Add New SubSection': 'નવું ઉપવિભાગ ઉમેરો',
	'Question Type': 'પ્રશ્નોનો પ્રકાર',
	'Question Name': 'પ્રશ્નોનું નામ',
	'Subsection Name': 'ઉપવિભાગનું નામ',
	Question: 'પ્રશ્નો',
	Answers: 'જવાબો',
	'Upload Question': 'પ્રશ્ન અપલોડ કરો',
	'Single Question': 'એકલ પ્રશ્ન',
	'Bulk Upload': ' સમૂહ અપલોડ',
	'Correct Answers': 'સાચા જવાબો',
	Marks: 'અંક',
	Explanation: 'સમજાવટ',
	Add: 'ઉમેરો',
	Update: 'અપડેટ',
	Cancel: 'રદ કરો',
	Create: 'બનાવો',
	Description: 'વર્ણન',
	'Allowed file formats: .csv, .xlsx': 'અનુમતિ ધરાવતી ફાઇલ ફોર્મેટ્સ: .csv, .xlsx',
	Tooltip: 'ક્રમ સંખ્યા | પ્રશ્ન પ્રકાર | પ્રશ્ન | જવાબ 1 | જવાબ 2 | જવાબ 3 | જવાબ 4',
	Tooltips: 'જવાબોની સંખ્યા | સમજાવટ | ગુણ | જવાબ વિકલ્પ | નકારાત્મક ગુણ (%)',
	'Headers Format': 'હેડર ફોર્મેટ',
	Submit: 'સબમિટ કરો'
}
